export default "__VITE_ASSET__DsPSNeEH__"